<template>
  <transition @enter="enter" @leave="leave" mode="out-in" :css="false">
    <button :key="content" class="puzzle-button" :class="{ close: inGame }">
      <span class="puzzle-button__bg" />
      <span class="puzzle-button__content">{{ content }}</span>
    </button>
  </transition>
</template>

<script>
import { animations, initials } from '../scripts/animations';

export default {
  name: 'PuzzleButton',

  props: {
    gameWon: {
      type: Boolean,
      required: true,
    },
    inGame: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    content() {
      let content;

      if (!this.inGame && !this.gameWon) {
        content = this.$translate('PLAY');
      } else if (this.inGame && !this.gameWon) {
        content = this.$translate('CLOSE');
      } else if (!this.inGame && this.gameWon) {
        content = this.$translate('PLAY_NEXT');
      }

      return content;
    },
  },

  methods: {
    enter(element, done) {
      initials.get('button')(element);
      animations.get('button')(element).finished.then(done);
    },
    leave(element, done) {
      animations.get('buttonOut')(element, element.classList.contains('close')).finished.then(done);
    },
  },
};
</script>

<style lang="scss" scoped>
.puzzle-button {
  display: block;
  position: absolute;
  bottom: -28px;
  left: 50%;
  width: 160px;
  height: 56px;
  margin-left: -80px;

  font-weight: 700;
  border-radius: 40px;
  border: transparent;
  background-color: transparent;

  z-index: 10;
  cursor: pointer;

  @include mq($from: ipadP, $until: dm) {
    font-size: 14px;
  }

  @include mq(dm) {
    width: 180px;
    height: 60px;
    bottom: -30px;
  }

  &.close {
    color: $color-beige;
    bottom: -60px;
    font-size: 16px;
  }

  .puzzle-button__bg {
    display: none;
    transition: transform 0.3s $outBack;
  }

  .puzzle-button__content {
    display: block;
    position: relative;
  }

  &:not(.close) {
    .puzzle-button__bg {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      border-radius: 28px;
      background-color: #eaeaea;
    }


    @include mq($and: $is-not-touch-device) {
      &[data-animated] {
        .puzzle-button__bg {
          transition: transform 0.3s $outBack;
        }

        &:hover .puzzle-button__bg {
          transform: scale(1.15);
        }
      }
    }

    .puzzle-button__content {
      letter-spacing: 1px;
    }
  }
}
</style>
